export function formatReadCount(count: number): string {
  if (count >= 10000) {
    return `${(count / 10000).toFixed(1)}万`;
  }
  return `${count}`;
}

export function formatDate(date: string): string {
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return date;
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function relativeDays(date: string): number {
  const d = new Date(date).getTime();
  if (Number.isNaN(d)) return 0;
  const diff = Date.now() - d;
  return Math.floor(diff / (1000 * 60 * 60 * 24));
}

export function isWithinRange(date: string, range: string): boolean {
  if (range === '全部时间' || !range) return true;
  const days = relativeDays(date);
  if (range === '最近一周') return days <= 7;
  if (range === '最近一月') return days <= 31;
  if (range === '最近三月') return days <= 92;
  return true;
}